<mat-card class="chart-card">
  <mat-card-header>
    <mat-card-title>Cronología de Goles</mat-card-title>
  </mat-card-header>
  <mat-card-content class="chart-card-content">

    <app-line-graph-chart
      *ngIf="transformedModel; else noData"
      [data]="transformedModel">
    </app-line-graph-chart>

    <ng-template #noData>
      <div class="no-data-container">
        <mat-icon>timeline</mat-icon>
        <span>No hay datos de cronología de goles disponibles.</span>
      </div>
    </ng-template>

  </mat-card-content>
</mat-card>
